import WalletAddressList from "./WalletAddressList";
import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import Sidebar from "./Sidebar";
import { useIntl } from "react-intl";
import { useWalletQueries } from "@lib/apiQueries";
import { SharedContextProps } from "@lib/types";
import { ROUTES } from "@lib/constants";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

const SharedWalletAddressBillingList: React.FC<SharedContextProps> = ({
  context,
  detailContext,
  customerId,
  leadId,
  customTitle,
  withoutContainer = false,
  withoutBreadcrumb,
  withoutSidebar = false,
  pageIsActive = true,
  height,
  tableProps,
}) => {
  const { messages } = useIntl();
  const { walletId } = useParams();

  const filter = [];

  const { walletsQuery } = useWalletQueries({
    messages,
    params: {
      sort: "createdAt,DESC",
      filter,
    },
  });

  const walletIdProp = useMemo(() => {
    const find = walletsQuery?.data?.data?.data?.find((w) => w.id === walletId);
    return find?.name || "";
  }, [walletId, walletsQuery?.data?.data?.data]);

  // Context-specific title and breadcrumb
  const title =
    customTitle ||
    (messages["sidebar.sendByteWndByteWalletAccounts"] as string);

  return (
    <AppsContainer
      height={height}
      noContainer={!!withoutContainer}
      title={title}
      breadcrumbProps={{
        urlParams: {
          [ROUTES.URL_PARAMS.WALLET_ID]: walletIdProp,
        },
      }}
      cardProps={{
        borderFull: true,
        coloredHeader: true,
      }}
      showBreadcrumb={!withoutBreadcrumb}
      sidebarContent={
        !withoutSidebar ? (
          <AppsContainer.SidebarCard>
            <Sidebar
              walletsQuery={walletsQuery}
              context={context}
              customerId={customerId}
              leadId={leadId}
            />
          </AppsContainer.SidebarCard>
        ) : null
      }
    >
      <WalletAddressList
        walletsQuery={walletsQuery}
        context={context}
        detailContext={detailContext}
        customerId={customerId}
        pageIsActive={pageIsActive}
        columnsConfig={tableProps?.columnsConfig}
      />
    </AppsContainer>
  );
};

export default SharedWalletAddressBillingList;
